// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__UvePa","title":"styles_title__qcGM9","input":"styles_input__Xa_TG","checkboxLabel":"styles_checkboxLabel__l4uEo"};